import { render, staticRenderFns } from "./ProductCoverSettings.vue?vue&type=template&id=a7eb0406"
import script from "./ProductCoverSettings.vue?vue&type=script&lang=js"
export * from "./ProductCoverSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports